import type React from "react";
import { Skeleton } from "@planta-v2/pds-ui/skeleton";
import { PorterOrb } from "@frontend/shared/presentation/components/PorterOrb";
import { i18n } from "@frontend/i18n";
import { GroupingSuggestionsList } from "../suggestions/GroupingSuggestionsList";
import type { Suggestion } from "@shared/schemas/suggestion.schemas";

export interface WhyConnectTabContentProps {
  readonly suggestions: readonly Suggestion[];

  readonly isLoading?: boolean;
}

function WhyConnectSkeleton(): React.JSX.Element {
  return (
    <div className="flex flex-col gap-6 pt-4">
      <div className="space-y-3">
        <Skeleton className="h-5 w-3/4" />
        <Skeleton className="h-5 w-1/2" />
        <Skeleton className="h-5 w-2/3" />
      </div>
    </div>
  );
}

export function WhyConnectTabContent({
  suggestions,
  isLoading = false,
}: WhyConnectTabContentProps): React.JSX.Element {
  if (isLoading) {
    return <WhyConnectSkeleton />;
  }

  if (suggestions.length === 0) {
    return (
      <div className="flex flex-col gap-6 pt-4">
        <p
          className="text-base text-muted-foreground"
          data-testid="why-connect-no-reasons-message"
        >
          {i18n.t("user.directory.profile.whyConnect.noReasons")}
        </p>
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-2 pt-4">
      <p className="flex items-center gap-1.5 text-pds-2xs text-muted-foreground">
        <PorterOrb className="size-3.5 shrink-0" />
        {i18n.t("participantProfile.aiSummary")}
      </p>
      <GroupingSuggestionsList
        suggestions={suggestions}
        className="text-pds-xs text-foreground"
      />
    </div>
  );
}
